import i18n from '@/i18n';

export const LANGUAGE_STORAGE_KEY = 'jph_portal_language';
/** Profile id of the subcontractor who explicitly chose a non-default language. */
export const SUBCONTRACTOR_EXPLICIT_USER_KEY = 'jph_portal_language_explicit_sub_user';

export type PortalUserType = 'management' | 'subcontractor' | 'client';

function dispatchLanguageChanged(language: string) {
  window.dispatchEvent(new CustomEvent('jph-language-changed', { detail: { language } }));
}

/** Apply i18n + localStorage language without marking an explicit subcontractor choice. */
export function setPortalLanguage(language: string) {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  if (i18n.language !== language) {
    i18n.changeLanguage(language);
  }
  dispatchLanguageChanged(language);
}

/**
 * Subcontractors default to English unless this profile id previously chose a language.
 * Does not touch auth/session state.
 */
export function applySubcontractorLanguageDefault(profileId: string) {
  const savedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';
  const explicitUserId = localStorage.getItem(SUBCONTRACTOR_EXPLICIT_USER_KEY);

  if (explicitUserId === profileId) {
    setPortalLanguage(savedLang);
    return;
  }

  setPortalLanguage('en');
}

/** Persist a user-selected language. Subcontractor choices are tied to profile id. */
export function persistLanguageChoice(
  language: string,
  userType?: PortalUserType,
  profileId?: string
) {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  if (userType === 'subcontractor' && profileId) {
    localStorage.setItem(SUBCONTRACTOR_EXPLICIT_USER_KEY, profileId);
  }
  if (i18n.language !== language) {
    i18n.changeLanguage(language);
  }
  dispatchLanguageChanged(language);
}
